import { MbscModule } from '@mobiscroll/angular';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { AlertController, IonicModule, IonicRouteStrategy, LoadingController, Platform } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { Chooser } from '@ionic-native/chooser/ngx';
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { ImageViewerComponent } from './component/image-viewer/image-viewer.component';
import { BusinessService, MobileService, OfflineManager, RequestService, Translate, TwoFactorAuth } from 'src/shared/shared';
import { NetworkService } from 'src/shared/networkService.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalNotifications } from '@capacitor/local-notifications';
import { ClientViewPage } from './client-view.page/client-view.page';
import { SharedModule } from 'src/shared/shared.module';
import { CoreService } from 'src/shared/chat/core-service.service';
import { Session } from 'src/shared/chat/entities/Session';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { CallingService } from 'src/shared/calling.service';
import { UserIdleModule } from 'angular-user-idle';
import { StorageService } from 'src/shared/storageservice';
import { SubscriptionService } from './calling-pages/subscription';
import { Uptime } from '@ionic-native/uptime/ngx';
import { UptimeService } from 'src/shared/uptimeService.service';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';
import { CommonService } from 'src/shared/commonService.service';
import { SpeechRecognition } from '@awesome-cordova-plugins/speech-recognition/ngx';

//Rollbar
import {
  RollbarService,
  rollbarFactory,
  RollbarErrorHandler
} from 'src/shared/rollbar.service';
import {
  ErrorHandler,
} from "@angular/core";
import { PipesModule } from './pipes.module';
import { AvailabilityPage } from './availability.page/availability.page';
import { OverrideSchedulePage } from './availability.page/override-schedule.page';
import { SlotModal } from './availability.page/slot-modal.page';


@NgModule({
  declarations: [
    AppComponent,
    ImageViewerComponent,
    ClientViewPage
  ],
  bootstrap: [AppComponent], imports: [MbscModule,
    BrowserModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    UserIdleModule.forRoot({ idle: 900, timeout: 1, ping: 120 }),
    PipesModule], providers: [
      SpeechRecognition,
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      Chooser,
      InAppBrowser,
      ImagePicker,
      OfflineManager,
      StorageService,
      MobileService,
      RequestService,
      SubscriptionService,
      BusinessService,
      Platform,
      NetworkService,
      LoadingController,
      AlertController,
      Translate,
      CoreService,
      Session,
      FingerprintAIO,
      CallingService,
      Uptime,
      UptimeService,
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      { provide: ErrorHandler, useExisting: RollbarErrorHandler },
      { provide: RollbarService, useFactory: rollbarFactory },
      Diagnostic,
      CommonService,
      provideHttpClient(withInterceptorsFromDi())
    ], schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
